module.exports = __webpack_public_path__ + "img/maison21.952e5304.jpg";